<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="8">
          <div class="form-group row header-custom-switch mb-0">
            <legend class="col-sm-12 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'combo_list'}" class="float-left mr-1 main-link">{{$t('combo.combo')}}</router-link> / {{$t('combo.detail')}}
                </h3>
              </strong>
            </legend>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="form-group row mb-0">
            <legend class="col-sm-2  offset-sm-8 col-form-label">{{$t('combo.active')}}</legend>
            <div class="col-sm-2 mt-1">
              <c-switch type="icon" size="lg" class="text-left" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.active" :value="1" :uncheckedValue="0"/>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer" class="header mb-0">
            <div slot="header">
              <span>
                <i className="fa fa-align-justify"></i><strong
                class="text-uppercase">{{ $t('combo.detail') }}</strong>
              </span>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus"
                     v-b-toggle.basic_information_content>
                <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row" v-if="item != null">
                <b-col cols="12" v-if="item.uuid!='' && item.publish == 1" v-show="checkShowByConfig('link_to_fcds')">
                  <b-row class="form-group">
                    <b-col cols="2">
                      {{$t('combo.link_to_fcds')}}
                    </b-col>
                    <b-col cols="10">
                      <a class="btn bg-main border-radius-4px pl-3 pr-3" :href="$store.getters.config.main.base_site_url + '/' + fcds.deal_detail + item.uuid" target="_blank">{{$t('common.view')}}</a>
                    </b-col>
                  </b-row>
                </b-col>
                
                <b-col cols="12">
                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" position="before" element="name_seo"></customize-field>
                  <b-form-group v-bind:label="$t('combo.short_name')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('name_seo')">
                    <b-form-input
                      class="form-control border-radius-4px"
                      v-model="item.short_name"
                      :state="!$v.item.short_name.$invalid"
                      :disabled="checkDisableByConfig('name_seo')"
                    />
                    <b-form-invalid-feedback :id="'name-seo-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" :label_cols="2" position="after" element="name_seo"></customize-field>
                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" :label_cols="2" position="before" element="code"></customize-field>

                  <b-form-group v-bind:label="$t('combo.id')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('id')">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px"
                      v-model="item.id"
                      :disabled="true"
                    />
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.code')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('sku')">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px"
                      v-model="item.sku"
                      :state="!$v.item.sku.$invalid"
                      :aria-describedby="'combo-code-feedback'"
                      :disabled="checkDisableByConfig('sku')"
                    />
                    <b-form-invalid-feedback :id="'combo-code-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" :label_cols="2" position="after" element="code"></customize-field>

                  <b-form-group v-bind:label="$t('menu.aggregator_code')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('aggregator_code')">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px"
                      v-model="item.aggregator_code"
                      :disabled="checkDisableByConfig('aggregator_code')"
                    />
                  </b-form-group>

                  <div class="form-group row" v-show="checkShowByConfig('name')">
                    <legend class="col-sm-2 col-form-label">{{$t('combo.marketing_name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="item.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                                    :aria-describedby="'combo-name-feedback'"
                                    :disabled="checkDisableByConfig('name')"
                                    @keyup="updateMenuURL"
                                    :state="checkShowByConfig('friendly_seo_name') ? '' : !$v.item.name.$invalid"
                      />
                      <b-form-invalid-feedback :id="'combo-name-feedback'">
                      {{ $t('message.required_filed') }}
                    </b-form-invalid-feedback>
                    </div>
                  </div>
                  <b-form-group v-bind:label="$t('menu.friendly_seo_name')" :label-cols="2" :horizontal="true"
                                v-show="checkShowByConfig('friendly_seo_name')">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px"
                      v-model="item.friendly_seo_name"
                      @keyup="editFriendlySeoName(item.friendly_seo_name)"
                      :disabled="checkDisableByConfig('friendly_seo_name')"
                    />
                  </b-form-group>

                  <div class="form-group row" v-show="checkShowByConfig('marketing_description')">
                    <legend class="col-sm-2 col-form-label">{{$t('combo.marketing_description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <count-text-area v-model="item.marketing_description[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('marketing_description')">
                      </count-text-area>
                    </div>
                  </div>
                  <div class="form-group row" v-show="checkShowByConfig('main_description')">
                    <legend class="col-sm-2 col-form-label">{{$t('combo.main_description')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <count-text-area v-model="item.main_description[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('main_description')">
                      </count-text-area>
                    </div>
                  </div>
                  <div class="form-group row" v-show="checkShowByConfig('t_and_c')">
                    <legend class="col-sm-2 col-form-label">{{$t('combo.t_and_c')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
                      <count-text-area :maxlength="1000" v-model="item.t_and_c[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('t_and_c')">
                      </count-text-area>
                    </div>
                  </div>
                  <b-form-group v-bind:label="$t('combo.category')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('category')">
                    <b-form-select class="border-radius-4px"
                                   v-model="item.category_id"
                                   :options="categories[$session.get('lang')]"
                                   v-bind:placeholder="$t('combo.category')"
                                   :disabled="checkDisableByConfig('category')"
                                   v-bind:selectLabel = "$t('combo.select_label')"
                                   v-bind:deselectLabel = "$t('combo.select_remove')"
                                   v-bind:selectedLabel = "$t('combo.selected')"
                                  />
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.display_category')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('display_category')">
                    <multiselect
                      class="border-radius-4px"
                      v-model="displayCategory"
                      v-bind:placeholder="$t('combo.display_category')"
                      label="text"
                      track-by="value"
                      :options="displayCategories.hasOwnProperty($session.get('lang')) ?  displayCategories[$session.get('lang')] : []"
                      :multiple="combo.config.multi_category"
                      :disabled="checkDisableByConfig('display_category')"
                      v-bind:selectLabel = "$t('combo.select_label')"
                      v-bind:deselectLabel = "$t('combo.select_remove')"
                      v-bind:selectedLabel = "$t('combo.selected')"
                    >
                    </multiselect>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.sub_category')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('sub_category')">
                    <multiselect
                      class="border-radius-4px"
                      v-model="subDisplayCategory"
                      v-bind:placeholder="$t('combo.sub_category')"
                      label="text"
                      track-by="value"
                      :options="subcategories.hasOwnProperty($session.get('lang')) ?  subcategories[$session.get('lang')] : []"
                      :multiple="combo.config.multi_sub_category"
                      group-values="sub" group-label="text" :group-select="combo.config.multi_sub_category"
                      :disabled="checkDisableByConfig('sub_category')"
                      v-bind:selectLabel = "$t('combo.select_label')"
                      v-bind:deselectLabel = "$t('combo.select_remove')"
                      v-bind:selectedLabel = "$t('combo.selected')"
                  >
                    </multiselect>
                  </b-form-group>

                  <div class="form-group row" v-show="checkShowByConfig('sale_channels')">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('common.sale_channel') }}
                    </legend>
                    <div class="col-sm-10">
                      <multiselect v-model="device_type"
                         v-bind:placeholder="$t('common.sale_channel')"
                         label="text" track-by="value"
                         :multiple="true"
                         :options="sale_channels[$session.get('lang')] || []"
                         :taggable="true"
                         v-bind:selectLabel="$t('combo.select_label')"
                         v-bind:deselectLabel="$t('combo.select_remove')"
                         v-bind:selectedLabel="$t('combo.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <div class="form-group row" v-if="config_attribute_combo">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('menu.combo-attribute') }}
                    </legend>
                    <div class="col-sm-10">
                      <multiselect v-model="displayAttributes"
                        v-bind:placeholder="$t('menu.combo-attribute')"
                        label="text" track-by="value"
                        :multiple="true"
                        :options="menuAttributeOptions"
                        :taggable="true"
                        v-bind:selectLabel="$t('menu.select_label')"
                        v-bind:deselectLabel="$t('menu.select_remove')"
                        v-bind:selectedLabel="$t('menu.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" :label_cols="2" type="combo" position="before" element="display_date"></customize-field>

                  <b-form-group v-bind:label="$t('combo.display_date')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('display_date')">
                    <div role="group" class="input-group">
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.display_start"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true"
                        :disabled="checkDisableByConfig('display_date')">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="date"
                        v-model="item.display_start"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        :disabled="checkDisableByConfig('display_date')"
                        formatInput="YYYY-MM-DD"
                        formatOutput="YYYY-MM-DD"
                        :shortMinute="true"
                        :errorClass="$v.item.display_start.$invalid ? 'error' : ''"
                        :change="(e) => item.display_start = e"
                      />
                      <b-form-invalid-feedback :id="'display_start-feedback'">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>

                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <date-picker-input
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="date"
                        v-model="item.display_end"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        :disabled="checkDisableByConfig('display_date')"
                        formatInput="YYYY-MM-DD"
                        formatOutput="YYYY-MM-DD"
                        :errorClass="$v.item.display_end.$invalid ? 'error' : ''"
                        :change="(e) => item.display_end = e"
                        :aria-describedby="'display_end-feedback'"
                      />
                      <b-form-invalid-feedback :id="'display_end-feedback'">
                        {{ $t('message.required_filed') }}
                      </b-form-invalid-feedback>

                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.display_end"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true"
                        :disabled="checkDisableByConfig('display_date')">
                      </masked-input>-->
                    </div>
                  </b-form-group>
                  <b-form-group v-bind:label="$t('combo.selling_date')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('selling_date')">
                    <div role="group" class="input-group">
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.selling_start"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true"
                        :disabled="checkDisableByConfig('selling_date')">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="date"
                        v-model="item.selling_start"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        :disabled="checkDisableByConfig('selling_date')"
                        formatInput="YYYY-MM-DD"
                        formatOutput="YYYY-MM-DD"
                        :change="(e) => item.selling_start = e"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <date-picker-input
                        className="form-control col-sm-3 float-left border-radius-4px"
                        name="date"
                        type="date"
                        v-model="item.selling_end"
                        :lang="$session.get('lang')"
                        :hasPicker="true"
                        :disabled="checkDisableByConfig('selling_date')"
                        formatInput="YYYY-MM-DD"
                        formatOutput="YYYY-MM-DD"
                        :change="(e) => item.selling_end = e"
                      />
                      <!--<masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-3 float-left border-radius-4px"
                        v-model="item.selling_end"
                        :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true"
                        :disabled="checkDisableByConfig('selling_date')">
                      </masked-input>-->
                    </div>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.duration_date')" :label-cols="2" :horizontal="true" label-class="duration-date" v-show="checkShowByConfig('duration_date')">
                    <b-form-input type="number" class="form-control border-radius-4px" v-model="item.duration_date" :disabled="checkDisableByConfig('duration_date')">
                    </b-form-input>
                  </b-form-group>

                  <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" :label_cols="2" position="after" element="display_date"></customize-field>

                  <b-form-group v-bind:label="$t('combo.sequence')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('sequence')">
                    <b-form-input type="number" class="form-control border-radius-4px" v-model="item.sequence" :disabled="checkDisableByConfig('sequence')">
                    </b-form-input>
                  </b-form-group>

                </b-col>

                <b-col cols="12" class="row m-0 p-0" v-show="checkShowByConfig('image')">
                  <div class="col-sm-6 row m-0 p-0 pt-3 mb-3" :class="`${index > 1 ? 'mt-4' : ''}`" v-for="(urlValue, keyName, index) in imageData" :key="`${keyName}-${imageDataKey}`">
                    <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
                      {{$t('combo.'+keyName)}}
                      <b-tooltip :target="'image-' + keyName" placement="top">
                        <div class="text-left" v-html="getImageHelpInfo('combo', keyName)"></div>
                      </b-tooltip>
                    </legend>
                    <div class="col-sm-8 img-min-height">
                      <b-form-file :id="keyName" @change="previewImage" accept="image/*"
                                   :placeholder="$t('message.choose_a_file')"></b-form-file>
                       <ImagePreview :url="urlValue" :keyUrl="keyName" @onDeleteImage="handleDeleteImage" />            
                    </div>
                  </div>
                </b-col>

                <b-col cols="12" class="pt-3 mt-4">
                  <b-row>
                    <b-col cols="2">
                      {{$t('combo.properties')}}
                    </b-col>
                    <b-col cols="10">
                      <b-row>
                        <div class="full-width">
                          <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" position="before" element="properties" col="3" label_cols="5"></customize-field>
                        </div>
                        <b-col cols="3">
                          <b-form-group v-bind:label="$t('combo.hidden')" :label-cols="5" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                      v-model="item.hide" :value="1" :uncheckedValue="0"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3">
                          <b-form-group v-bind:label="$t('combo.delivery')" :label-cols="5" :horizontal="true" v-show="checkShowByConfig('delivery')">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                      v-model="delivery" :checked="delivery" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('delivery')"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3">
                          <b-form-group v-bind:label="$t('combo.takeaway')" :label-cols="5" :horizontal="true" v-show="checkShowByConfig('collection')">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                      v-model="takeaway" :checked="takeaway" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('collection')"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3">
                          <b-form-group v-bind:label="$t('common.restaurant')" :label-cols="5" :horizontal="true" v-show="checkShowByConfig('eat_in')">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                      v-model="dinein" :checked="dinein" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('eat_in')"/>
                          </b-form-group>
                        </b-col>

                        <b-col cols="3" v-show="checkShowByConfig('only_lunch')">
                          <b-form-group v-bind:label="$t('combo.only_lunch')" :label-cols="5" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.only_lunch" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('only_lunch')"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3" v-show="checkShowByConfig('day_of_hut')">
                          <b-form-group v-bind:label="$t('combo.day_of_hut')" :label-cols="5" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.day_of_hut" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('day_of_hut')"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3" v-show="checkShowByConfig('discount')">
                          <b-form-group v-bind:label="$t('combo.discount')" :label-cols="5" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.discount" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('discount')"/>
                          </b-form-group>
                        </b-col>
                        <b-col cols="3" v-show="checkShowByConfig('is_donation')">
                          <b-form-group v-bind:label="$t('combo.is_donation')" :label-cols="5" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.is_donation" :value="1" :uncheckedValue="0" :disabled="checkDisableByConfig('is_donation')"/>
                          </b-form-group>
                        </b-col>
                        <div class="full-width">
                          <customize-field prefix="combo" :update="updateCustomizeField" :item="item" type="combo" position="after"
                                           element="day_of_hut" col="3" label_cols="5"></customize-field>
                        </div>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('combo.type_title')" :label-cols="2" :horizontal="true">
                    <b-form-select v-model="item.type" v-bind:value="item.type"
                                   :options="type_statuses[$session.get('lang')]"
                                   v-bind:placeholder="$t('combo.type_title')">
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('combo.allow_type')" :label-cols="2" :horizontal="true" v-show="checkShowByConfig('allow_type')">
                    <multiselect
                            class="border-radius-4px"
                            v-model="allow_type"
                            v-bind:placeholder="$t('combo.allow_type')"
                            label="text"
                            track-by="value"
                            :options="allow_type_statuses[$session.get('lang')]"
                            :multiple="true" attr-a="true"
                            v-bind:selectLabel="$t('combo.select_label')"
                            v-bind:deselectLabel="$t('combo.select_remove')"
                            v-bind:selectedLabel="$t('combo.selected')"
                            :disabled="checkDisableByConfig('allow_type')"
                    >
                    </multiselect>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="pt-3">
                  <b-form-group v-bind:label="$t('combo.owner_code')" :label-cols="2" :horizontal="true" v-if="owner_codes && owner_codes.length > 0">
                    <multiselect
                      class="border-radius-4px"
                      v-model="owner_code"
                      v-bind:placeholder="$t('combo.owner_code')"
                      label="text"
                      track-by="value"
                      :options="owner_codes"
                      :multiple="true" attr-a="true"
                      v-bind:selectLabel="$t('combo.select_label')"
                      v-bind:deselectLabel="$t('combo.select_remove')"
                      v-bind:selectedLabel="$t('combo.selected')"
                    >
                    </multiselect>
                  </b-form-group>
                </b-col>
                <!-- opening hours and special date -->
                <b-col cols="12" v-if="combo.opening_times">
                  <h4 class="title">{{$t('combo.available')}}</h4>
                </b-col>

                <!-- Part of Days of Week -->
                <b-col cols="4" v-if="combo.opening_times">
                  <b-form-group :label-cols="3" :horizontal="true" v-for="day in daysOfWeek" :key="day.id"
                                v-bind:label="$t(day)">
                    <div role="group" class="input-group">
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <b-form-checkbox v-model="item.opening_times[day].active" :value="1"
                                           :unchecked-value="0"></b-form-checkbox>
                        </div>
                      </div>
                      <masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left border-radius-4px"
                        v-model="item.opening_times[day].opening"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>
                      <div class="input-group-append">
                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                      </div>
                      <masked-input
                        type="text"
                        name="date"
                        class="form-control col-sm-6 float-left border-radius-4px"
                        v-model="item.opening_times[day].closing"
                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                        :guide="true"
                        placeholderChar="_"
                        :showMask="true"
                        :keepCharPositions="true">
                      </masked-input>
                    </div>
                  </b-form-group>
                </b-col>
                <!-- End of Days of Week -->

                <!-- Part of Special Date -->
                <b-col cols="8" v-if="combo.special_date">
                  <b-form-group :label-cols="11" v-bind:label="$t('combo.special_date')">
                    <table class="table table-bordered table-hover">
                      <thead>
                      <tr>
                        <th>{{$t('combo.name')}}</th>
                        <th>{{$t('combo.date')}}</th>
                        <th>{{$t('combo.time')}}</th>
                        <th>{{$t('combo.open')}}</th>
                        <th>{{$t('combo.active')}}</th>
                        <th>{{$t('combo.action')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(date, index) in item.special_dates" :key="date.id">
                        <td>
                          <b-form-input class="form-control" v-model="item.special_dates[index].name">
                          </b-form-input>
                        </td>
                        <td>
                          <masked-input
                            type="text"
                            name="date"
                            class="form-control"
                            v-model="item.special_dates[index].date"
                            :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                            :guide="true"
                            placeholderChar="_"
                            :showMask="true"
                            :keepCharPositions="true">
                          </masked-input>
                        </td>
                        <td>
                          <div role="group" class="input-group">
                            <masked-input
                              type="text"
                              name="date"
                              class="form-control col-sm-6 float-left"
                              v-model="item.special_dates[index].from"
                              :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                              :guide="true"
                              placeholderChar="_"
                              :showMask="true"
                              :keepCharPositions="true">
                            </masked-input>
                            <div class="input-group-append">
                              <div class="input-group-text"><i class="fa fa-minus"></i></div>
                            </div>
                            <masked-input
                              type="text"
                              name="date"
                              class="form-control col-sm-6 float-left"
                              v-model="item.special_dates[index].to"
                              :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                              :guide="true"
                              placeholderChar="_"
                              :showMask="true"
                              :keepCharPositions="true">
                            </masked-input>
                          </div>
                        </td>
                        <td>
                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                    v-model="item.special_dates[index].status"
                                    :checked="item.special_dates[index].status" :value="1" :uncheckedValue="0"/>
                        </td>
                        <td>
                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                    v-model="item.special_dates[index].active"
                                    :checked="item.special_dates[index].active" :value="1" :uncheckedValue="0"/>
                        </td>
                        <td>
                          <b-button variant="danger" v-on:click="removeSpecialDate(index)" size="sm"><i
                            class="fa fa-trash-o"></i></b-button>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6">
                          <b-button variant="success" v-on:click="addSpecialDate()"><i class="fa fa-plus"></i>
                          </b-button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-form-group>
                </b-col>
                <!-- End of Special Date -->


              </b-form>
            </b-collapse>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.push({name: 'combo', query: {rollback: 1}})"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              </div>
              <div class="statuses">
                <b-row class="bs-wizard" style="border-bottom:0;">

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 1 ? 'complete' : '') +
                  (item.content_status == 1 ? 'active' : '') +
                  (item.content_status < 1 ? 'disabled' : '')">
                    <div class="text-center bs-wizard-stepnum">{{$t('combo.new')}}</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot"></a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 2 ? 'complete' : '') +
                  (item.content_status == 2 ? 'active' : '') +
                  (item.content_status < 2 ? 'disabled' : '')"><!-- complete -->
                    <div class="text-center bs-wizard-stepnum">{{$t('combo.editing')}}</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot"></a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 3 ? 'complete' : '') +
                  (item.content_status == 3 ? 'active' : '') +
                  (item.content_status < 3 ? 'disabled' : '')"><!-- complete -->
                    <div class="text-center bs-wizard-stepnum">{{$t('combo.ready_to_publish')}}</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot"></a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 4 ? 'hide' : '') +
                  (item.content_status == 4 ? 'active' : '') +
                  (item.content_status < 4 ? 'disabled' : '')" v-if="item.content_status <= 4"><!-- active -->
                    <div class="text-center bs-wizard-stepnum">{{$t('menu.published')}}</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot"></a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 75 ? 'hide' : '') +
                  (item.content_status == 75 ? 'running' : '') +
                  (item.content_status < 75 ? 'hide' : '')" v-if="item.content_status == 75"><!-- active -->
                    <div class="text-center bs-wizard-stepnum">{{$t('menu.publishing')}}...</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot">
                      <i class="fa-spin fa fa-refresh"></i>
                    </a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>

                  <b-col :class="'bs-wizard-step ' +
                  (item.content_status > 99 ? 'hide' : '') +
                  (item.content_status == 99 ? 'error' : '') +
                  (item.content_status < 99 ? 'hide' : '')" v-if="item.content_status == 99"><!-- active -->
                    <div class="text-center bs-wizard-stepnum">{{$t('menu.published_fail')}}</div>
                    <div class="progress"><div class="progress-bar"></div></div>
                    <a href="#" class="bs-wizard-dot">
                      <i class="fa fa-times-circle-o"></i>
                    </a>
                    <div class="bs-wizard-info text-center"></div>
                  </b-col>
                </b-row>
              </div>
              <div class="btn-save">
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="publishCombo" v-if="item != null && item.content_status == 3"> {{$t('common.publish')}}
                </button>
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3"
                  v-on:click="readyPublish"
                  v-if="item != null && item.content_status < 3"
                  :disabled="uuid == 'create'"
                > {{$t('common.ready_to_publish')}}
                </button>
                <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3" v-on:click="$refs.copyModal.show()" :disabled="item.content_status == 75">{{$t('common.copy')}}</button>
                <button type="button"  class="btn bg-main border-radius-4px" v-on:click="saveCombo()" :disabled="checkSubmit() || item.content_status == 75"> {{$t('common.save')}}</button>
              </div>
            </div>

          </b-card>
          <b-card v-if="combo.config.combo_price" class="mb-0">
            <!-- Part of Single Price -->
            <div slot="header">
              <span class="text-uppercase">{{$t('common.price_setting')}}</span>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updatePriceStatus"
                     v-b-toggle.price_content>
                <i class="fa fa-sort-down" v-if="priceStatus"></i>
                <i class="fa fa-sort-up" v-if="!priceStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="priceStatus" :id="'price_content'">
              <b-row>
                <div class="col-sm-6">
                  <b-form-group v-bind:label="$t('combo.display_price')" :label-cols="3" :horizontal="true">
                    <b-form-input type="text" class="form-control border-radius-4px" v-model="item.display_price">
                    </b-form-input>
                  </b-form-group>
                </div>
              </b-row>
              <b-row v-for="(price, p) in item.prices" :key="price.id">
                <b-container fluid class="pl-3 pr-3">
                  <div class="col-sm-6" v-if="combo.config.combo_multi_price">
                    <b-form-group v-bind:label="$t('combo.date_release')" :label-cols="3" :horizontal="true">
                      <div role="group" class="input-group">
                        <masked-input
                          type="text"
                          name="date"
                          class="form-control col-sm-6 float-left border-radius-4px"
                          v-model="item.prices[p].from"
                          :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                          :guide="true"
                          placeholderChar="_"
                          :showMask="true"
                          :keepCharPositions="true">
                        </masked-input>
                        <div class="input-group-append">
                          <div class="input-group-text"><i class="fa fa-minus"></i></div>
                        </div>
                        <masked-input
                          type="text"
                          name="date"
                          class="form-control col-sm-6 float-left border-radius-4px"
                          v-model="item.prices[p].to"
                          :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                          :guide="true"
                          placeholderChar="_"
                          :showMask="true"
                          :keepCharPositions="true">
                        </masked-input>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="col-sm-6" v-if="combo.config.product_tax_price">
                    <b-form-group v-bind:label="$t('menu.tax_rate')" :label-cols="3" :horizontal="true">
                      <input type="number" class="form-control" v-model="item.prices[p].tax_rate"/>
                    </b-form-group>
                  </div>
                </b-container>

                <!-- Part of Tier Prices -->
                <div class="col-sm-6" v-for="(name, index) in tier" :key="index+0" v-if="combo.config.combo_price">
                  <b-card v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                    <b-form-group v-bind:label="$t('common.base_price')" :label-cols="3" :horizontal="true" v-if="Object.keys(tier).length == 1">
                      <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="item.prices[p].price[index]" v-bind:placeholder="$t('common.base_price')" :disabled="checkDisableByConfig('price')">
                      </b-form-input>
                    </b-form-group>
                    <b-form-group v-bind:label="$t('menu.price')" :label-cols="3" :horizontal="true" v-if="Object.keys(tier).length > 1">
                      <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="item.prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('price')">
                      </b-form-input>
                    </b-form-group>

                    <!-- <input type="hidden" class="form-control" v-model="item.prices[p].price_without_tax[index]"/> -->
                    <b-form-group v-bind:label="$t('menu.price_without_tax')" :label-cols="3" :horizontal="true" v-if="combo.config.product_tax_price">
                      <input type="number" class="form-control" v-model="item.prices[p].price_without_tax[index]"/>
                    </b-form-group>

                    <b-form-group v-bind:label="$t('menu.point')" :label-cols="3" :horizontal="true" v-if="combo.config.product_point">
                      <input type="number" class="form-control" v-model="item.prices[p].point[index]"/>
                    </b-form-group>

                  </b-card>
                </div>

                <!-- <div class="clearfix col-12" v-if="combo.config.combo_multi_price">
                  <hr/>
                </div> -->
                <!-- End of Tier Prices -->

                <b-col cols="12" v-if="combo.config.combo_multi_price" class="text-right">
                  <b-button variant="danger" v-on:click="removePriceToSinge(p)"><i class="fa fa-trash-o"></i>&nbsp;
                    {{$t('combo.price')}}
                  </b-button>
                </b-col>
                <div class="clearfix col-12" v-if="combo.config.combo_multi_price">
                  <hr/>
                </div>
              </b-row>
              <b-row>
                <b-col cols="12" v-if="combo.config.combo_multi_price">
                  <button class="btn bg-main border-radius-4px" type="button" v-on:click="addPriceToSinge"><i class="fa fa-plus"></i>&nbsp;
                    {{$t('combo.price')}}
                  </button>
                </b-col>
              </b-row>
            </b-collapse>
            <!-- End of Single Price -->
          </b-card>
          <b-card class="mb-0">
            <div slot="header">
              <span class="text-uppercase">{{$t('combo.group_information')}}</span>
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateComboGroupStatus"
                     v-b-toggle.combo_group_content>
                <i class="fa fa-sort-down" v-if="comboGroupStatus"></i>
                <i class="fa fa-sort-up" v-if="!comboGroupStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="comboGroupStatus" :id="'combo_group_content'">
              <b-row>
                <b-col cols="6">
                  <b-form-group v-bind:label="$t('combo.group_detail')" :label-cols="4" :horizontal="true">
                    <button type="button" class="btn border-radius-4px bg-main" @click="$router.push({ name: 'edit_combo_group',  params: { uuid: uuid }})" :disabled="item.uuid == ''">{{$t('combo.view_group_information')}}</button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <b-card class="mb-0">
            <div slot="header" class="text-uppercase">
              {{$t('combo.customise')}}
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateCustomiseStatus"
                     v-b-toggle.customise_content>
                <i class="fa fa-sort-down" v-if="customiseStatus"></i>
                <i class="fa fa-sort-up" v-if="!customiseStatus"></i>
              </label>
            </div>

            <b-collapse :visible.sync="customiseStatus" id="customise_content">
              <b-row>
                <b-col cols="12" v-if="combo.config.opening_hours || combo.config.special_date">
                  <b-form-group v-bind:label="$t('combo.day_part')" :label-cols="2" :horizontal="true">
                    <button type="button" class="btn border-radius-4px bg-main"
                            @click="$router.push({ name: 'combo_available',  params: { uuid: uuid }})"
                            :disabled="item.uuid == ''">{{$t('combo.view_day_part')}}
                    </button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>

          </b-card>

          <!-- Start SEO Configuration -->
          <seo-configuration v-if="isShowSEOConfiguration()" ref="seoConfiguration" :seo-url="seoUrl" :itemSingle="item"></seo-configuration>
          <!-- End SEO Configuration -->

          <!-- Store and Store group -->
          <!-- STORE AVAILABILITY SETTINGS -->

          <b-card>
            <div slot="header" class="text-uppercase">
              {{$t('combo.store_availability_settings')}}
              <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateStoreSettingsStatus" v-b-toggle.store_settings>
                <i class="fa fa-sort-down" v-if="storeSettings"></i>
                <i class="fa fa-sort-up" v-if="!storeSettings"></i>
              </label>
            </div>
            <b-collapse :visible.sync="storeSettings" id="store_settings">
              <div v-if="isDefaultApplicable">
                <b-row class="form-group">
                  <b-col cols="12">
                    <span>{{$t('combo.applicable_default')}}</span>
                  </b-col>
                </b-row>
                <b-row class="form-group">
                  <b-col cols="12">
                    <b-form-group v-bind:label="$t('combo.applicable_wanna')" :label-cols="2" :horizontal="true"  >
                      <button type="button" class="btn bg-main border-radius-4px" v-on:click="$refs.storeModal.show()" >&nbsp;{{$t('combo.customize')}}</button>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else>
                <b-row>
                  <b-col cols="12">
                    <b-form-group v-bind:label="$t('menu.applicable_store')" :label-cols="2" :horizontal="true"  >
                      <button type="button" class="btn bg-main border-radius-4px" v-on:click="updateItemDataToDefault">&nbsp;{{$t('combo.reset_to_default')}}</button>
                      <button type="button" class="btn bg-main border-radius-4px" v-on:click="$refs.storeModal.show()" >&nbsp;{{$t('combo.customize')}}</button>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="2">
                    <b-form-select :options="store_filter.options" v-model="store_filter.selected" @change="refreshData()">
                    </b-form-select>
                  </b-col>
                  <b-col cols="8">
                    <b-input-group>
                      <input type="text" class="form-control" v-model="store_filter.key" v-on:keydown.enter="refreshData"/>
                      <div class="input-group-append">
                        <b-input-group-append>
                          <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                        </b-input-group-append>
                      </div>
                    </b-input-group>
                  </b-col>
                  <b-col cols="2">
                    <b-input-group v-bind:prepend="$t('menu.status')">
                      <b-form-select v-model="store_filter.status" :options="store_statuses[$session.get('lang')]" v-bind:placeholder="$t('menu.active')" @change="refreshData()">
                      </b-form-select>
                    </b-input-group>
                  </b-col>
                </b-row>
                <div class="clearfix pt-05"></div>
                <b-row>
                  <b-col cols="12">
                    <table class="table table-striped table-hover table-sm header-pointer">
                      <thead>
                      <tr>
                        <th scope="col" v-for="item in dataTable.fields" :key="item.id" @click="updateSort(item.name)" >
                          <i class="fa fa-sort-amount-asc text-muted" v-if="dataTable.sort.type == 'asc' && dataTable.sort.field == item.name"></i>
                          <i class="fa fa-sort-amount-desc text-muted" v-if="dataTable.sort.type == 'desc' && dataTable.sort.field == item.name"></i>
                          <span >{{$t('store.'+item.name)}}</span>
                        </th>
                        <th scope="col" v-if="!(uuid == 'create' || uuid == undefined)">{{$t('common.action')}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="dataTable.items.length == 0">
                        <td class="text-center" :colspan="dataTable.fields.length + 3">
                          {{$t('message.no_data')}}
                        </td>
                      </tr>
                      <tr v-for="storeT in dataTable.items" :key="storeT.id">
                        <td scope="row" v-for="field in dataTable.fields" :key="field.id" >
                          <span v-if="field.render != null" v-html="field.render(storeT[field.name], storeT)"></span>
                          <span v-if="field.render == null">
                        {{storeT[field.name]}}
                      </span>
                        </td>
                        <td scope="row" >
                          <b-button size="sm" variant="primary" v-on:click="deleteStoreItem(item.uuid, storeT.uuid)" v-if="!(uuid == 'create' || uuid == undefined)">
                            <i class="fa fa-trash color-red"></i>
                          </b-button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <!-- Start of paginate session -->
                    <b-row>
                      <b-col>
                        <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                      </b-col>
                      <b-col class="text-left">
                        {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                      </b-col>
                      <b-col col lg="1">
                        <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]" class="mb-3"/>
                      </b-col>
                    </b-row>
                    <!-- Start of paginate session -->
                  </b-col>
                </b-row>
              </div>
            </b-collapse>
          </b-card>
          <!-- End Store and Store group -->
        </b-col>
      </b-row>
    </div>
    <!-- New Map -->
    <b-modal class="modal-store-group" ref="storeModal"
             v-bind:title="$t('combo.customize_item')" size="lg" body-class="padding-none"
             :hide-header="false" ok-variant=" bg-main border-radius-4px pl-3 pr-3"
             v-model="modelShowApplicable" :hide-footer="false"
             :ok-title="$t('common.save')"
             ok-only @ok="needReset=false;updateItemData()" >
      <store-modal :stores="store_option"
                   :store-groups="store_group"
                   :stores-temp="store_temp"
                   :store-groups-temp="store_group_temp"
                   :stores-exclude="store_exclude_option"
                   :stores-exclude-temp="store_exclude_temp"
                   :store-list-origin="storeListOrigin"></store-modal>
    </b-modal>
    <!-- End New map -->

    <!-- Copy -->
    <b-modal class="modal-copy" ref="copyModal" v-bind:title="$t('combo.copy_data')" size="xl" body-class="padding-none" ok-variant="bg-main border-radius-4px pl-3 pr-3">
      <b-row>
        <b-col>
          <div class="form-group row">
            <legend class="col-sm-2 col-form-label">{{$t('combo.combos')}}</legend>
            <div class="col-sm-10">
              <multiselect
                class="border-radius-4px"
                v-model="copied_combo"
                label="text"
                track-by="value"
                :options="combos_selection.hasOwnProperty($session.get('lang')) ?  combos_selection[$session.get('lang')] : []"
                :multiple="false"
                v-bind:selectLabel = "$t('combo.select_label')"
                v-bind:deselectLabel = "$t('combo.select_remove')"
                v-bind:selectedLabel = "$t('combo.selected')"
                v-bind:placeholder = "$t('combo.placeholder')"
              >
              </multiselect>
            </div>
          </div>
          <div class="form-group row" v-show="checkShowByConfig('name')">
            <legend class="col-sm-2 col-form-label">{{$t('combo.marketing_name')}}</legend>
            <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
              <b-form-input type="text"
                            :name="`name[${lang}]`"
                            class="form-control border-radius-4px"
                            v-model="copied_combo.value.name[lang]"
                            v-bind:placeholder="$t('common.text_' + lang)"
                            :disabled="checkDisableByConfig('name')"
              />
            </div>
          </div>
          <div class="form-group row" v-show="checkShowByConfig('marketing_description')">
            <legend class="col-sm-2 col-form-label">{{$t('combo.marketing_description')}}</legend>
            <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
              <count-text-area v-model="copied_combo.value.marketing_description[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('marketing_description')">
              </count-text-area>
            </div>
          </div>
          <div class="form-group row" v-show="checkShowByConfig('main_description')">
            <legend class="col-sm-2 col-form-label">{{$t('combo.main_description')}}</legend>
            <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
              <count-text-area v-model="copied_combo.value.main_description[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('main_description')">
              </count-text-area>
            </div>
          </div>
          <div class="form-group row" v-show="checkShowByConfig('t_and_c')">
            <legend class="col-sm-2 col-form-label">{{$t('combo.t_and_c')}}</legend>
            <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id">
              <count-text-area v-model="copied_combo.value.t_and_c[lang]" :placeholder="$t('common.text_' + lang)" :disabled="checkDisableByConfig('t_and_c')">
              </count-text-area>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="row m-0 p-0" v-show="checkShowByConfig('image')">
          <div class="col-sm-6 row m-0 p-0 pt-3" v-for="(data, image, index) in imageData" :key="data.id">
            <legend class="col-sm-4 col-form-label" :class="{'text-right': (index % 2)}">
              {{$t('combo.'+image)}}
              <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
              <b-tooltip :target="'image-' + image" placement="top">
                <div class="text-left" v-html="getImageHelpInfo('combo', image)"></div>
              </b-tooltip>
            </legend>
            <div class="col-sm-8 ">
              <b-form-input type="text" class="form-control border-radius-4px" v-model="copied_combo.value.image[image]" />
            </div>
            <div v-bind:class="'image-' + image + '-preview img-min-height-modal'" class="col-sm-8 offset-sm-4">
              <ImagePreview :url="copied_combo.value.image[image]" :keyUrl="image"
              :isModal="true" @onDeleteImageModal="handleDeleteImageModal" />
            </div>
          </div>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <button type="button" class="btn border-radius-4px" v-on:click="$refs.copyModal.hide()">{{$t('common.cancel')}}</button>
        <button type="button" class="btn bg-main border-radius-4px" v-on:click="copyItem">{{$t('common.apply')}}</button>
      </div>
    </b-modal>
    <!-- End Copy -->
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue, requiredIf} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import CountTextArea from '../../../components/Partials/CountTextArea'
  import Tables from '../../tables/Tables'
  import Multiselect from 'vue-multiselect'
  import StoreModal from './ModalStore'
  import DatePickerInput from '@/components/Partials/DatePickerInput'
  import ImagePreview from '@/components/Partials/ImagePreview'
  import SeoConfiguration from '../../../components/Partials/SeoConfiguration'

  import axios from 'axios'
  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null
  let defaultDateFrom = '01-01-2008'
  const defaultDateTo = '31-12-9999'
  const PRODUCT_TILE_LIMIT = 60
  const META_DESCRIPTION_LIMIT = 160

  export default {
    name: 'ComboForm',
    props: {
      uuid: {
        type: String
        // required: true
      }
    },
    components: {
      Tables,
      cSwitch,
      vSelect,
      MaskedInput,
      CustomizeField,
      Multiselect,
      StoreModal,
      CountTextArea,
      DatePickerInput,
      ImagePreview,
      SeoConfiguration
    },
    data: function () {
      return {
        config_attribute_combo: this.$store.getters.config.gms.combo.config.combo_attributes ? this.$store.getters.config.gms.combo.config.combo_attributes : false,
        countFlagApplicable: 0,
        circle_load: null,
        combos_selection: {},
        sale_channels: {},
        device_type: [],
        copied_combo: {
          value: {
            name: {},
            marketing_description: {},
            main_description: {},
            t_and_c: {},
            image: {}
          }
        },
        modelShowApplicable: null,
        needReset: false,
        applicableBeforeOpen: {
          store_temp: [],
          store_exclude_temp: [],
          store_option: [],
          store_exclude_option: [],
          store_group: [],
          store_group_temp: []
        },
        isDefaultApplicable: true,
        isEmptyApplicable: false,
        storeListOrigin: [],
        storeGroupListOrigin: [],
        store_group: [],
        store_option: [],
        store_exclude_option: [],
        store_exclude_temp: [],
        storeSelling: 0,
        storeNotSelling: 0,
        store_group_temp: [],
        store_temp: [],
        updateCustomizeField: true,
        fcds: this.$auth.user().config.fcds,
        tier: this.$store.getters.config.main.tiers,
        combo: this.$store.getters.config.gms.combo,
        images: ['desktop_thumbnail', 'desktop_detail', 'mobile_thumbnail', 'mobile_detail'],
        currency: this.$store.getters.config.gms.currency_info,
        daysOfWeek: this.$auth.user().config.days_of_week,
        types: [],
        categories: [],
        displayCategories: [],
        displayCategory: null,
        dataDisplayCategories: {},
        subcategories: [],
        subDisplayCategory: null,
        type: {
          input: "",
          textarea: "",
          switch: false
        },
        item: {
          id: null,
          uuid: '',
          category_id: '',
          sku: '',
          aggregator_code: '',
          name_seo: '',
          friendly_seo_name: '',
          short_name: '',
          display_start: '',
          display_end: '',
          prices: [],
          name: {},
          t_and_c: {},
          disposition: [],
          marketing_description: {},
          main_description: {},
          display_categories: [],
          customize: {},
          device_type: [],
          image: {},
          active: 1,
          hide: 0,
          discount: 1,
          is_donation: 0,
          only_lunch: 0,
          day_of_hut: 0,
          sequence: 0,
          display_price: 0,
          duration_date: 0,
          opening_times: [],
          special_dates: [],
          content_status: 1,
          store_content: {
            exclude_stores: [],
            store_groups: [],
            stores: []
          },
          type: 0,
          allow_type: null,
          attributes: []
        },
        menuAttributes: {},
        menuAttributeOptions: [],
        displayAttributes: [],
        type_statuses: [],
        allow_type_statuses: [],
        allow_type : null,
        owner_code: null,
        owner_codes: [],
        takeaway: 1,
        delivery: 1,
        dinein: 1,
        imageData: {},
        imageDataKey: 0,
        priceStatus: true,
        basicInformationStatus: true,
        comboGroupStatus: true,
        storeSettings: true,
        customiseStatus: true,
        store_statuses: [],
        dataTable: {
          items: [],
          fields: [
            {
              name: 'code',
              text: this.$t('store.code'),
              value: 'code',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'name',
              text: this.$t('store.name'),
              value: 'name',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'area_code',
              text: this.$t('store.area_code'),
              value: 'area_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'jpchar',
              text: this.$t('store.jpchar'),
              value: 'jpchar',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_code',
              text: this.$t('store.owner_code'),
              value: 'owner_code',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'owner_name',
              text: this.$t('store.owner_name'),
              value: 'owner_name',
              filter: true,
              sort: false,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data
              }
            },
            {
              name: 'address',
              text: this.$t('store.address'),
              value: 'address',
              filter: true,
              sort: true,
              render: (data, row) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            }
          ],
          sort: {
            field: 'name',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        store_filter: {
          options: [],
          selected: 'code',
          key: '',
          status: '',
          name: '',
          code: ''
        },
        seoConfigurationStatus: false,
        clientId: 0,
        itemId: 0,
        comboUrl: this.$store.getters.config.main.base_site_url,
        seoUrl: ''
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        sequence: {
          required,
          minValue: 0,
          integer
        },
        short_name: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        sku: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        name: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        display_start: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        display_end: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        selling_start: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
        selling_end: {
          required: requiredIf(function (nestedModel) {
            return !this.isJapanMarket()
          }),
        },
      }
    },
    methods: {
      getSaleChannels(){
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.sale_channels[lang] = [
          {
            value: "web",
            text: vm.$t('common.web', lang)
          },
          {
            value: "iphone",
            text: vm.$t('common.ios', lang)
          },
          {
            value: "android",
            text: vm.$t('common.android', lang)
          },
          {
            value: "callcenter",
            text: vm.$t('common.callcenter', lang)
          }
        ]
      }
    },
      escapeRegExp (string) {
        return string.replace(/[^a-zA-Z0-9]+/g, '-')
      },
      updateMenuURL () {
        let vm = this
        if(this.checkShowByConfig('friendly_seo_name')) {
          let name = vm.item.name['en'].trim() ? vm.escapeRegExp(vm.item.name['en'].trim()): ''
          vm.item.friendly_seo_name = name.toLowerCase()
        }
          
      },
      editFriendlySeoName (nameSeo) {
        let vm = this
        let name = nameSeo.trim() ? vm.escapeRegExp(nameSeo.trim()): ''
        vm.item.friendly_seo_name = name.toLowerCase()
      },
      goBack () {
        this.$router.push({name: 'combo', query: this.$route.query})
      },
      checkShowByConfig (key) {
        if (this.combo == null) {
          return true
        }
        let config = this._.find(this.combo.basic_info, function (o) {
          return o.type === key
        })
        if (config == null) {
          return false
        }
        return config.show
      },
      checkDisableByConfig (key) {
        if (this.item.content_status == 75) {
          return true
        }
        if (this.combo == null) {
          return false
        }
        let config = this._.find(this.combo.basic_info, {type: key})
        if (config == null) {
          return false
        }
        return config.disable
      },
      isShowSEOConfiguration() {
        if (vm.combo == null) {
          return true
        }
        const data = _.get(vm.combo, 'config.seo_configuration', false)
        return data
      },
      updateSEOUrl (val) {
        if('' != val) {
          vm.seoUrl = `${vm.comboUrl}/combo-detail/${val}`
        } else {
          if('' != vm.item.uuid) {
            vm.seoUrl = `${vm.comboUrl}/combo-detail/${vm.item.uuid}`
          } else {
            vm.seoUrl = ''
          }
        }
      },
      publishCombo () {
        if (vm.item != null && vm.item.id != null) {
          vm.axios.menu.publishCombo({
            'scope': 'partial',
            'bulk': [vm.item.id]
          }, function (response) {
            vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
            vm.item.content_status = 75
            vm.ids = []
            vm.circle_load = setInterval(() => {
              vm.axios.menu.getComboContentStatus('ids=' + vm.item.id, function (response) {
                let count = 0
                for (let i in response.data.data) {
                  let item = response.data.data[i]
                  if (item.id == vm.item.id) {
                    vm.item.content_status = item.content_status
                    if (item.content_status != 75) {
                      count++
                    }
                  }
                }

                if (count >= response.data.data.length) {
                  clearInterval(vm.circle_load)
                }
              })
            }, 60000)
            vm.refreshData()
          })
        }
      },
      getListCombo () {
        // get params
        let _data = {
          page: 1,
          limit: 500,
          sort_field: 'name',
          sort_type: 'asc',
          active: 1
        }

        // process to send via get method
        let params = ''
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        // remove tail
        params = params.slice(0, -1)

        vm.axios.menu.getComboList(params, function (response) {
          let items = response.data.data.items
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.combos_selection[langs[l]] = []
          }
          for (let i in items) {
            for (let l in langs) {
              vm.combos_selection[langs[l]].push({
                text: items[i].name != null ? items[i].name[langs[l]] + ' - ' + items[i].sku : items[i].sku,
                value: items[i]
              })
            }

            if (vm.config_attribute_combo) {
              for (let key in items[i].menu_attributes) {
                vm.displayAttributes.push({
                value: item.menu_attributes[key]['uuid'],
                text: item.menu_attributes[key]['name'][vm.$session.get('lang')]
              })
            }
          }
          }
          vm.$forceUpdate('combos_selection')
        })
      },
      copyItem () {
        vm.item.name = vm.copied_combo.value.name
        vm.item.marketing_description = vm.copied_combo.value.marketing_description
        vm.item.main_description = vm.copied_combo.value.main_description
        vm.item.t_and_c = vm.copied_combo.value.t_and_c
        vm.item.image = vm.copied_combo.value.image
        vm.imageData = vm.item.image
        this.$refs.copyModal.hide()
      },
      updateStoreSettingsStatus () {
        this.storeSettings = !this.storeSettings
      },
      readyPublish: function () {
        vm.axios.menu.readyPublicCombo(vm.uuid, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.item.content_status = 3
        }, function (error) {
          if (error.error.data.groups || error.error.data.group_items) {
            vm.$toastr.error(vm.$t('message.combo_missing_group_or_item'), vm.$t('message.error'), {})
          } else {
            vm.$toastr.error(vm.$t('message.error'), vm.$t('message.success'), {})
          }
        })
      },
      /**
       * remove special date from list
       * @param index
       */
      removeSpecialDate (index) {
        let dates = []
        for (let i in vm.item.special_dates) {
          if (i != index) {
            dates.push(vm.item.special_dates[i])
          }
        }
        vm.item.special_dates = dates
      },
      /**
       * add special date to list with default attribute
       */
      addSpecialDate () {
        vm.item.special_dates.push({
          name: '',
          from: '08:00:00',
          to: '02:00:00',
          date: this.$moment().format('DD-MM-YYYY'),
          status: 1,
          active: 1
        })
      },
      checkSubmit: function () {
        let validateName = this.checkShowByConfig('friendly_seo_name') ? vm.nameState() : false
        let form = vm.$v.item.$invalid
        let result = form
        return result || validateName
      },
      nameState: function (lang) {
        let checkItemName = false
      for (let index = 0; index < this.$store.getters.languages.length; index++) {
        let lang = this.$store.getters.languages[index];
        if (vm.item.name[lang] != undefined && vm.item.name[lang] && vm.item.name[lang] != '') {
          checkItemName =  false
        } else {
          return true
        }
      }
      
      return checkItemName;
      },
      /**
       * remove price of single product
       * @param index
       */
      removePriceToSinge (index) {
        let prices = []

        for (let i in this.item.prices) {
          if (i != index) {
            prices.push(this.item.prices[i])
          }
        }

        this.item.prices = prices
      },
      /**
       * add price to single product
       */
      addPriceToSinge () {
        let prices = {}
        for (let t in vm.tier) {
          prices[t] = 0
        }
        this.item.prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: prices,
          price_without_tax: prices,
          tax_rate: 0,
          active: 1
        })
      },
      updateCustomiseStatus() {
        this.customiseStatus = !this.customiseStatus
      },
      /**
       * update status of price session
       */
      updatePriceStatus () {
        this.priceStatus = !this.priceStatus
      },
      updateComboGroupStatus () {
        this.comboGroupStatus = !this.comboGroupStatus
      },
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      /**
      * update status of seo configuration session
      */
      updateSeoConfigurationStatus() {
        this.seoConfigurationStatus = !this.seoConfigurationStatus
      },
      /**
       * preview image after select
       * @param event
       */
      previewImage (event) {
        let input = event.target

        if (input.files && input.files[0]) {
          let reader = new FileReader()

          reader.onload = (e) => {
            this.imageData[input.id] = e.target.result
          }
          let data = {}
          for (let i in this.images) {
            data[this.images[i]] = this.imageData[this.images[i]]
          }
          this.imageData = data
          reader.readAsDataURL(input.files[0])
          this.item.image[input.id] = input.files[0]
        }
      },
      processAfterSuccess () {
        vm.item.store_content.stores = []
        vm.store_exclude_temp = []
        vm.store_exclude_option = []
        vm.item.store_content.store_groups = []
        let outltesUuid = []
        for (let i in vm.store_temp) {
          vm.item.store_content.stores.push(vm.store_temp[i].uuid)
          let indexO = vm.item.store_content.exclude_stores.indexOf(vm.store_temp[i].uuid)
          if (indexO >= 0) {
            vm.item.store_content.exclude_stores.splice(indexO, 1)
          }
        }
        for (let i in vm.store_group_temp) {
          vm.item.store_content.store_groups.push(vm.store_group_temp[i].uuid)
          outltesUuid = outltesUuid.concat(vm.store_group_temp[i].outlet_ids)
        }
        for (let i in vm.storeListOrigin) {
          if (outltesUuid.indexOf(vm.storeListOrigin[i].uuid) >= 0) {
            let storeValue = {
              name_tmp: vm.storeListOrigin[i].code + ' - ' + vm.storeListOrigin[i].name,
              name: vm.storeListOrigin[i].name,
              uuid: vm.storeListOrigin[i].uuid,
              code: vm.storeListOrigin[i].code,
              id: vm.storeListOrigin[i].id
            }
            if (vm.item.store_content.exclude_stores.indexOf(vm.storeListOrigin[i].uuid) >= 0) {
              vm.store_exclude_temp.push(storeValue)
            } else {
              vm.store_exclude_option.push(storeValue)
            }
          }
        }
        vm.refreshData()
      },
      resetApplicable () {
        vm.store_group = vm._.cloneDeep(vm.storeGroupListOrigin)
        vm.store_option = vm._.cloneDeep(vm.storeListOrigin)
        vm.store_exclude_option = []
        vm.store_group_temp = []
        vm.store_temp = []
        vm.store_exclude_temp = []
        vm.item.store_content.exclude_stores = []
      },
      /**
       * upload data
       */
      deleteStoreItem (uuid, storeUuid) {
        let data = {
          menu_type: 'combo',
          store_uuid: storeUuid,
          uuid: vm.item.uuid
        }
        vm.isEmptyApplicable = false
        vm.processing = true
        vm.axios.deleteMenuStoreContent(data, function (response) {
          vm.$toastr.success(vm.$t('message.delete_successful'), vm.$t('message.success'), {})
          vm.processing = false
          for (let i in vm.store_temp) {
            if (vm.store_temp[i].uuid == storeUuid) {
              vm.store_option.push(vm.store_temp[i])
              vm.store_temp.splice(i, 1)
            }
          }
          for (let i in vm.store_exclude_option) {
            if (vm.store_exclude_option[i].uuid == storeUuid) {
              vm.store_exclude_temp.push(vm.store_exclude_option[i])
              vm.store_exclude_option.splice(i, 1)
            }
          }
          let indexO = vm.item.store_content.exclude_stores.indexOf(storeUuid)
          if (indexO < 0) {
            vm.item.store_content.exclude_stores.push(storeUuid)
          }
          vm.item.content_status = 2
          vm.processAfterSuccess()
        }, function () {
          vm.processing = false
          vm.$toastr.error(vm.$t('message.delete_fail'), vm.$t('message.delete_fail'), {})
        })
      }, /**
       * upload data
       */
      updateItemDataToDefault () {
        let options = {
          html: true,
          okText: vm.$t('common.reset'),
          cancelText: vm.$t('common.keepit')
        }
        vm.$dialog.confirm(vm.$t('combo.reset_default_confirm'), options)
          .then(function (dialog) {
            vm.isDefaultApplicable = true
            vm.resetApplicable()
            vm.processAfterSuccess()
            if (vm.uuid == 'create' || vm.uuid == undefined) {
              return false
            }
            let data = {
              store_groups: [],
              resetToDefault: true,
              stores: [],
              uuid: vm.item.uuid
            }
            vm.processMenuStore(data)
          })
          .catch(function () {
          })
      },
      processMenuStore (data) {
        vm.processing = true
        data.menu_type = 'combo'
        vm.axios.updateMenuStoreContent(data, function (response) {
          vm.$toastr.success(vm.$t('message.update_applicable_successful'), vm.$t('message.success'), {})
          vm.processing = false
          if (data.hasOwnProperty('exclude_stores') ) {
            let newUuids = []
            // reset exclude stores
            if (data['exclude_stores']['add']) {
              newUuids = vm._.cloneDeep(data['exclude_stores']['add'])
            }
            vm.item.store_content.exclude_stores = newUuids
          }
          vm.item.content_status = 2
          vm.processAfterSuccess()
        }, function () {
          vm.processing = false
          vm.$toastr.error(vm.$t('message.update_applicable_failed'), vm.$t('message.update_fail'), {})
        })
      },
      /**
       * upload data then move to next form
       */
      updateItemData () {
        vm.isDefaultApplicable = false
        if (vm.uuid == 'create' || vm.uuid == undefined) {
          vm.processAfterSuccess()
          return false
        }
        let storeUuids = []
        let storeExcludeUuids = []
        let storeExcludeRemove = []
        let storeOptionUuid = []
        for (let i in vm.applicableBeforeOpen.store_group_temp) {
          storeUuids.push(vm.applicableBeforeOpen.store_group_temp[i].uuid)
        }
        for (let i in vm.store_exclude_temp) {
          storeExcludeUuids.push(vm.store_exclude_temp[i].uuid)
          if (vm.item.store_content.exclude_stores.indexOf(vm.store_exclude_temp[i].uuid) < 0) {
            vm.item.store_content.exclude_stores.push(vm.store_exclude_temp[i].uuid)
          }
        }
        for (let i in vm.store_group_temp) {
          if (storeUuids.indexOf(vm.store_group_temp[i].uuid) < 0) {
            storeOptionUuid.push(vm.store_group_temp[i].uuid)
          }
        }
        for (let i in vm.applicableBeforeOpen.store_exclude_temp) {
          if (storeExcludeUuids.indexOf(vm.applicableBeforeOpen.store_exclude_temp[i].uuid) < 0) {
            storeExcludeRemove.push(vm.applicableBeforeOpen.store_exclude_temp[i].uuid)
            if (vm.item.store_content.exclude_stores.indexOf(vm.applicableBeforeOpen.store_exclude_temp[i].uuid) >= 0) {
              vm.item.store_content.exclude_stores.slice(vm.item.store_content.exclude_stores.indexOf(vm.applicableBeforeOpen.store_exclude_temp[i].uuid), 1)
            }
          }
        }
        let data = {
          store_groups: vm._.cloneDeep(vm.store_group_temp),
          stores: vm._.cloneDeep(vm.store_temp),
          exclude_stores: {
            add: storeExcludeUuids,
            remove: storeExcludeRemove
          },
          store_group_option: storeOptionUuid,
          resetToDefault: true,
          uuid: vm.item.uuid
        }
        if (vm.store_temp.length > 0 || vm.store_group_temp.length > 0) {
          data.resetToDefault = false
        }
        if (data.store_groups.length >= 0 || data.stores.length >= 0) {
          vm.isEmptyApplicable = false
        }
        if (data.resetToDefault) {
          vm.resetApplicable()
        }
        vm.processMenuStore(data)
      },
      /**
       * upload image then move to next form
       */
      saveCombo (redirect = false) {
        let item = JSON.parse(JSON.stringify(vm.item))
        if (item.name_seo == '' || item.name_seo == null) {
          item.name_seo = item.short_name
        }
        let _prices = {}
        let _points = {}

        for (let _t in vm.tier) {
          _prices[_t] = 0
        }
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.item.image) {
          if (vm.item.image[i] && vm.item.image[i].type != undefined) {
            formData.append(i, vm.item.image[i])
          } else {
            oldUrl[i] = vm.item.image[i]
          }
        }
        let ids = []
        if (vm.displayCategory) {
          if (vm._.isArray(vm.displayCategory)) {
            for (let d in vm.displayCategory) {
              ids.push(vm.displayCategory[d].value)
            }
          } else {
            ids.push(vm.displayCategory.value)
          }
        }
        item.display_categories = ids

        let types = []
        if (vm.allow_type) {
          if (vm._.isArray(vm.allow_type)) {
            for (let d in vm.allow_type) {
              types.push(vm.allow_type[d].value)
            }
          } else {
            types.push(vm.allow_type.value)
          }
        }
        item.allow_type = types

        let ownerCodes = []
        if (vm.owner_code) {
          if (vm._.isArray(vm.owner_code)) {
            for (let d in vm.owner_code) {
              ownerCodes.push(vm.owner_code[d].value)
            }
          } else {
            ownerCodes.push(vm.owner_code.value)
          }
        }
        item.owner_code = ownerCodes

        let subIds = []
        if (vm.subDisplayCategory) {
          if (vm._.isArray(vm.subDisplayCategory)) {
            for (let d in vm.subDisplayCategory) {
              subIds.push(vm.subDisplayCategory[d].value)
            }
          } else {
            subIds.push(vm.subDisplayCategory.value)
          }
        }
        item.sub_display_categories = subIds

        // process menu attribute
        item.attributes = []
        if (vm.config_attribute_combo) {
          let attributes = []
          console.log("vm.displayAttributes", vm.displayAttributes)
          for (let a in vm.displayAttributes) {
            attributes.push(vm.displayAttributes[a]['value'])
          }
          item.attributes = attributes
        }
        
        // Process customize items

        let config = {'Content-Type': 'multipart/form-data'}
        // call an API to save image
        vm.axios.menu.uploadComboImages(formData, config, function (response) {
          item.image = {}

          for (let i in vm.images) {
            item.image[vm.images[i]] = ''
          }

          for (let i in response.data.data.item) {
            item.image[i] = response.data.data.item[i]
          }
          // get old url
          for (let i in oldUrl) {
            item.image[i] = oldUrl[i]
          }

          let firstImage = ''
          for (let i in vm.images) {
            if (oldUrl[vm.images[i]] != null && oldUrl[vm.images[i]] != '') {
              firstImage = oldUrl[vm.images[i]]
            }
            if (firstImage != null || firstImage != '') {
              if (response.data.data[vm.images[i]] != null && response.data.data[vm.images[i]] != '') {
                firstImage = response.data.data[vm.images[i]]
              }
            }
            break
          }

          for (let i in vm.images) {
            if ((item.image[vm.images[i]] == null || item.image[vm.images[i]] == '') && (firstImage != null && firstImage != '')) {
              item.image[vm.images[i]] = firstImage
            }
          }

          for (let i in vm.images) {
            if (item.image[vm.images[i]] == null) {
              item.image[vm.images[i]] = ''
            }
          }
          vm.imageData = item.image

          // Process system date
          item.display_start = item.display_start
          item.display_end = item.display_end + ' 23:59:59'
          item.selling_start = item.selling_start
          item.selling_end = item.selling_end + ' 23:59:59'

          for (let p in vm.item.prices) {
            item.prices[p].from = vm.revertDateFormat(item.prices[p].from) + ' 00:00:00'
            item.prices[p].to = vm.revertDateFormat(item.prices[p].to) + ' 23:59:59'
            item.prices[p].price = vm.removePropertiesNotExistObject(Object.assign({}, item.prices[p].price), Object.keys(vm.tier))
            item.prices[p].price_without_tax = vm.removePropertiesNotExistObject(Object.assign({}, item.prices[p].price_without_tax), Object.keys(vm.tier))
            item.prices[p].point = vm.removePropertiesNotExistObject(Object.assign({}, item.prices[p].point), Object.keys(vm.tier))
            for (let pp in item.prices[p].price) {
              item.prices[p].price[pp] = item.prices[p].price[pp] || 0
            }
            for (let pp in item.prices[p].price_without_tax) {
              item.prices[p].price_without_tax[pp] = item.prices[p].price_without_tax[pp] || 0
            }
            for (let pp in item.prices[p].point) {
              item.prices[p].point[pp] = parseFloat(item.prices[p].point[pp]) || 0
            }
            if (!item.prices[p].price || Object.keys(item.prices[p].price).length === 0) {
              item.prices[p].price = _prices
            }
            if (!item.prices[p].price_without_tax || Object.keys(item.prices[p].price_without_tax).length === 0) {
              item.prices[p].price_without_tax = _prices
            }
            if (!item.prices[p].point || Object.keys(item.prices[p].point).length === 0) {
              item.prices[p].point = _points
            }
          }

          let customize = {}
          let fields = vm.combo.fields
          for (let i = 0; i < fields.length; i++) {
            let field = fields[i]
            for (let j in field.body) {
              if(!item[field.body[j].name]){
                customize[field.body[j].name] = vm.type[field.body[j].input_type]
              }else{
                customize[field.body[j].name] = item[field.body[j].name]
              }
              delete item[field.body[j].name]
            }
          }
          item.customize = vm._.cloneDeep(customize)
          item.customize.sale_from = vm.revertDateFormat(item.customize.sale_from)
          item.customize.sale_to = vm.revertDateFormat(item.customize.sale_to)
          if(vm.isShowSEOConfiguration() && !vm.$refs.seoConfiguration.checkRequire()) {
            this.processing = false
            return
          }
          //Save SEO Configuration
          // just for KW
          let clientUuid = localStorage.getItem('clientID')
          if (vm.isShowSEOConfiguration() && clientUuid === vm.client_uuid.kw) {
            let params = vm.$refs.seoConfiguration.getSeoConfigurationParams()
            item.customize['seo_configuration'] = params
          }

          // processing opening_times
          item.opening_times = []
          for (let j in vm.item.opening_times) {
            item.opening_times.push(vm.item.opening_times[j])
          }

          // processing special dates
          for (let p in vm.item.special_dates) {
            item.special_dates[p].date = vm.revertDateFormat(item.special_dates[p].date)
          }

          item.disposition = []
          if (vm.takeaway == 1) {
            item.disposition.push('C')
          }
          if (vm.delivery == 1) {
            item.disposition.push('D')
          }
          if (vm.dinein == 1) {
            item.disposition.push('R')
          }

          //------- sale channels
          item.device_type = []
          if (vm.checkShowByConfig('sale_channels')) {
            for(let i of vm.device_type) {
              item.device_type.push(i.value)
            }
          }
          //--------------
          item.friendly_seo_name = ''
          if(vm.checkShowByConfig('friendly_seo_name') && vm.item.friendly_seo_name) {
            item.friendly_seo_name = vm.item.friendly_seo_name 
          }
          // call an API to save combo information
          // check create or update
          vm.item.content_status = 2
          if (vm.uuid == 'create' || vm.uuid == undefined) {
            vm.axios.menu.createCombo(item, function (response) {
              let uuid = response.data.data.item.uuid
              let newItem = vm._.get(response, 'data.data.item', {})
              vm.$root.$emit('createOrUpdateSEOConfiguration')
              vm.item.uuid = newItem.uuid || ''
              vm.item.id = newItem.id || 0
              if(vm.checkShowByConfig('friendly_seo_name')) {
                let name = vm.item.name['en'].trim() ? vm.escapeRegExp(vm.item.name['en'].trim()): ''
                vm.updateSEOUrl(newItem.friendly_seo_name || name.toLowerCase())
              } else {
                vm.updateSEOUrl()
              }
              if (vm.store_group_temp.length > 0 || vm.store_temp.length > 0) {
                let data = {
                  store_groups: vm._.cloneDeep(vm.store_group_temp),
                  stores: vm._.cloneDeep(vm.store_temp),
                  resetToDefault: false,
                  menu_type: 'combo',
                  uuid: uuid
                }
                vm.processMenuStore(data)
              }
              vm.item.uuid = uuid
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.$router.push({name: 'combo_edit', params: {uuid: uuid}})
              if (redirect) {
                vm.$router.push({name: 'create_combo_group', params: {uuid: uuid}})
              } else {
                // vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              }
            })
          } else { // update
            item.content_status = 2
            vm.axios.menu.updateCombo(item,
              function (response) {
                let uuid = response.data.data.item.uuid
                vm.$root.$emit('createOrUpdateSEOConfiguration')
                if (redirect) {
                  vm.$router.push({name: 'edit_combo_group', params: {uuid: uuid}})
                } else {
                  vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                }
              },
              function (error) {
                if (error.error.data.groups || error.error.data.group_items) {
                  vm.$toastr.error(vm.$t('message.combo_missing_group_or_item'), vm.$t('message.error'), {})
                }
              }
            )
          }
        })
      },
      /**
       * get list categories for select box
       */
      getListCategories () {
        vm.axios.menu.getListDisplayCategories('level=1', function (response) {
          vm.displayCategories = []
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.displayCategories[langs[l]] = []
            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
                vm.displayCategories[langs[l]].push({
                  value: item['id'],
                  text: item['name'][langs[l]]
                })
              }
              let lowerCategories = []
              for (let i in item['lower_categories']) {
                if (item['lower_categories'][i].status == 1) {
                  lowerCategories.push(item['lower_categories'][i])
                }
              }
              vm.dataDisplayCategories['id_' + item['id']] = {
                name: item['name'],
                lower_categories: lowerCategories
              }
            }
          }
          vm.refreshDisplayCategory()
        })
        vm.axios.menu.getListCategories(function (response) {
          vm.categories = []
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.categories[langs[l]] = [{
              value: null,
              text: vm.$t('combo.select_category', langs[l])
            }]
            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
                vm.categories[langs[l]].push({
                  value: item['id'],
                  text: item['name'][langs[l]]
                })
              } else {
                vm.categories[langs[l]].push({
                  value: item['id'],
                  text: 'Invalid Name (' + item['sku'] + ')'
                })
              }
            }
          }
        })
      },
      /**
       * convert date from YYYY-MM-DD to DD-MM-YYYY
       * @param val
       * @returns {*}
       */
      convertDateFormat (val) {
        let newDate = vm.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
        return (val == 'Invalid date' || val == '__-__-____') ? val : newDate
      },
      /**
       * update sort field and sort type then refresh data
       * @param field
       */
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
            return
          }
        }
        if (this.dataTable.sort.field != field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type == 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * Refesh data
       */
      refreshData () {
        if (cancel != null) {
          cancel()
        }

        if (vm.isEmptyApplicable) {
          vm.dataTable.items = []
          vm.dataTable.total = 0
          return false
        }
        let params = { 'limit': this.dataTable.perPage, 'page': this.dataTable.currentPage, 'sort_by': this.dataTable.sort.field, 'order_by': this.dataTable.sort.type }
        if (!this._.isEmpty(this.store_filter.selected) && !this._.isEmpty(this.store_filter.key)) {
          params[this.store_filter.selected] = this.store_filter.key.trim()
        }
        if (this.store_filter.status != '') {
          params['active'] = this.store_filter.status
        }
        params.outlet_uuids = vm.item.store_content.stores
        params.exclude_outlet_uuids = vm.item.store_content.exclude_stores
        params.outlet_group_uuids = vm.item.store_content.store_groups
        if (params.outlet_uuids.length <= 0 && params.outlet_group_uuids.length <= 0 && params.exclude_outlet_uuids.length > 0) {
          vm.dataTable.items = []
          vm.dataTable.total = 0
          vm.isEmptyApplicable = true
          return false
        }
        if (params.outlet_uuids.length <= 0 && params.outlet_group_uuids.length <= 0 && params.exclude_outlet_uuids.length <= 0) {
          vm.isDefaultApplicable = true
          vm.isEmptyApplicable = false
          vm.dataTable.items = []
          vm.dataTable.total = 0
          return false
        }
        vm.$bus.$emit('loading', 'block')
        this.axios.outlet.getPostOutletList(params, {
          cancelToken: new CancelToken(function executor (c) {
            cancel = c
          })},
        function (response) {
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.pagination.total
          vm.$bus.$emit('loading', 'none')
        },
        function (error) {
          vm.$bus.$emit('loading', 'none')
        })
      },
      /**
       * revert date from DD-MM-YYYY to YYYY-MM-DD
       * @param val
       * @returns {*}
       */
      revertDateFormat (val) {
        let newDate = vm.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
        return (val == 'Invalid date' || val == '__-__-____') ? val : newDate
      },
      refreshDisplayCategory () {
        vm.subcategories = {}
        let langs = vm.$store.getters.languages
        let sub = []
        for (let l in langs) {
          vm.subcategories[langs[l]] = []
          if (vm.displayCategory != null) {
            if (vm._.isArray(vm.displayCategory)) {
              for (let i in vm.displayCategory) {
                let category = vm.displayCategory[i]
                if (vm.dataDisplayCategories['id_' + category.value] != null) {
                  let item = {
                    text: vm.dataDisplayCategories['id_' + category.value].name[langs[l]],
                    sub: []
                  }
                  for (let j in vm.dataDisplayCategories['id_' + category.value].lower_categories) {
                    let subcategory = vm.dataDisplayCategories['id_' + category.value].lower_categories[j]
                    if (subcategory.status == 1) {
                      item.sub.push({
                        text: subcategory.name[langs[l]],
                        value: subcategory.id
                      })
                      sub.push(subcategory.id)
                    }
                  }
                  vm.subcategories[langs[l]].push(item)
                }
              }
            } else {
              let category = vm.displayCategory
              if (vm.dataDisplayCategories['id_' + category.value] != null) {
                let item = {
                  text: vm.dataDisplayCategories['id_' + category.value].name[langs[l]],
                  sub: []
                }
                for (let j in vm.dataDisplayCategories['id_' + category.value].lower_categories) {
                  let subcategory = vm.dataDisplayCategories['id_' + category.value].lower_categories[j]
                  if (subcategory.status == 1) {
                    item.sub.push({
                      text: subcategory.name[langs[l]],
                      value: subcategory.id
                    })
                    sub.push(subcategory.id)
                  }
                }
                vm.subcategories[langs[l]].push(item)
              }
            }
          }
        }
        let subDisplayCategories = []
        for (let j in vm.subDisplayCategory) {
          if (sub.indexOf(vm.subDisplayCategory[j].value) >= 0) {
            subDisplayCategories.push(vm.subDisplayCategory[j])
          }
        }
        vm.subDisplayCategory = subDisplayCategories
      },
      checkFlagAplicable () {
        this.countFlagApplicable++
        if (this.countFlagApplicable >= 2) {
          this.processAfterSuccess()
        }
      },
      getStatusData () {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.type_statuses[langs[l]] = [
            {text: vm.$t('combo.type_normal', langs[l]), value: 0},
            {text: vm.$t('combo.type_up_sale', langs[l]), value: 1},
            {text: vm.$t('combo.type_add_on', langs[l]), value: 3},
            {text: vm.$t('combo.type_hut_reward', langs[l]), value: 4},
            {text: vm.$t('combo.type_free_item', langs[l]), value: 5}
          ]

          vm.allow_type_statuses[langs[l]] = [
            {text: vm.$t('combo.type_normal', langs[l]), value: 0},
            {text: vm.$t('combo.type_condiment', langs[l]), value: 1},
            {text: vm.$t('combo.type_cutlery', langs[l]), value: 2},
            {text: vm.$t('combo.type_up_sale', langs[l]), value: 3},
            {text: vm.$t('combo.type_hut_reward', langs[l]), value: 4},
            {text: vm.$t('combo.type_free_item', langs[l]), value: 5}
          ]
        }

        vm.owner_codes = []
        if(this.$store.getters.config.manual_config.owner_code) {
          const ownerCodes = JSON.parse(this.$store.getters.config.manual_config.owner_code)
          for(let i in ownerCodes) {
            vm.owner_codes.push({text: ownerCodes[i], value: ownerCodes[i]})
          }
        }
      },
      getMenuAttributes() {
        let data = 'type=2'
        vm.axios.menu.getMenuAttributeSimple(data, function (response) {
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            vm.menuAttributes[langs[l]] = []
            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
                vm.menuAttributes[langs[l]].push({
                  value: item['uuid'],
                  text: item['name'][langs[l]]
                })
              }
            }
          }
        })
      },

      handleDeleteImage(imageKey) {
        vm.imageData[`${imageKey}`] = ''
        vm.item.image[`${imageKey}`] = ''
        vm.imageDataKey += 1
      },

      handleDeleteImageModal(imageKey) {
        vm.copied_combo.value.image[`${imageKey}`] = '';
      }
    },

    created: function () {
      vm = this
      vm.META_DESCRIPTION_LIMIT = META_DESCRIPTION_LIMIT
      vm.PRODUCT_TILE_LIMIT = PRODUCT_TILE_LIMIT
      vm.getSaleChannels()
      vm.getListCombo()
      vm.getStatusData()
      vm.getListCategories()
      if (vm.config_attribute_combo) {
        vm.getMenuAttributes()
      }
      vm.updateCustomizeField = false

      // Initial opening_times value
      for (let i in vm.daysOfWeek) {
        vm.item.opening_times[vm.daysOfWeek[i]] = {
          day: vm.daysOfWeek[i],
          opening: '08:00:00',
          closing: '23:00:00',
          active: 1
        }
      }
      vm.clientId = vm._.get(vm.$store.getters.config, 'base.id', 0)
    },
    updated: function () {
    if (vm.menuAttributes[vm.$session.get('lang')] !== undefined && vm.config_attribute_combo) {
      vm.menuAttributeOptions = vm.menuAttributes[vm.$session.get('lang')]
    }
  },
    mounted: function () {
      vm.getStatusData()
      defaultDateFrom = this.$moment().format('DD-MM-YYYY')
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        vm.store_statuses[langs[l]] = [
          {text: vm.$t('common.all', langs[l]), value: ''},
          {text: vm.$t('common.active', langs[l]), value: '1'},
          {text: vm.$t('common.inactive', langs[l]), value: '0'}
        ]
      }

      for (let i in vm.dataTable.fields) {
        let field = vm.dataTable.fields[i].name
        if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
          vm.store_filter.options.push(vm.dataTable.fields[i])
        }
        if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      if (vm.uuid == 'create' || vm.uuid == undefined) {
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = ''
        }
        vm.imageData = data
        vm.item.category_id = null
        vm.item.customize.sale_from = '2008-01-01'
        vm.item.customize.sale_to = '9999-12-31'
        vm.item.selling_start = vm.item.sale_from = vm.revertDateFormat(defaultDateFrom)
        vm.item.sale_to = vm.revertDateFormat(defaultDateTo)
        vm.item.display_start = vm.revertDateFormat(defaultDateFrom)
        vm.item.selling_end = vm.item.display_end = vm.revertDateFormat(defaultDateTo)

        let prices = {}
        let points = {}
        for (let t in vm.tier) {
          prices[t] = 0
          points[t] = 0
        }
        vm.item.prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: prices,
          price_without_tax: prices,
          point: points,
          tax_rate: 0,
          active: 1
        })

        vm.updateCustomizeField = true
        // get store group list
        vm.axios.outlet.getStoreGroupList('?limit=9999', function (respone) {
          let result = respone.data.data.items
          for (let i in result) {
            let groupValue = {name_tmp: result[i].name[vm.$session.get('lang')], name: result[i].name, uuid: result[i].uuid, id: result[i].id, outlet_ids: result[i].outlet_ids}
            vm.store_group.push(groupValue)
            vm.storeGroupListOrigin.push(groupValue)
          }
        }, error => {
          console.log('error', error)
        })

        // get store list
        vm.axios.outlet.getStoreListUnlimit('?disposition=ALL', function (respone) {
          let result = respone.data.data.items
          for (let i in result) {
            let storeValue = {  name_tmp: result[i].code + ' - ' + result[i].name,
                                name: result[i].name,
                                uuid: result[i].uuid,
                                id: result[i].id,
                                code : result[i].code
                            }
            vm.store_option.push(storeValue)
            vm.storeListOrigin.push(storeValue)
          }
        }, error => {
          console.log(error)
        })

      } else {
        vm.axios.menu.getComboDetail(vm.uuid, function (response) {
          let item = JSON.parse(JSON.stringify(response.data.data.item))
          vm.itemId = item.id
          if (item.short_name == null || item.short_name == '') {
            item.short_name = item.name_seo
          }
          item.store_content = {
            stores: [],
            exclude_stores: [],
            store_groups: []
          }

          for (let i in item.applicable_stores) {
            item.store_content.stores.push(item.applicable_stores[i].outlet_uuid)
          }
          for (let i in item.applicable_exclude_stores) {
            item.store_content.exclude_stores.push(item.applicable_exclude_stores[i].outlet_uuid)
          }
          for (let i in item.applicable_store_groups) {
            item.store_content.store_groups.push(item.applicable_store_groups[i].outlet_group_uuid)
          }
          if (item.applicable_stores.length == 1 && vm._.isEmpty(item.applicable_stores[0].outlet_uuid)) {
            vm.isEmptyApplicable = true
          }
          if (item.store_content.stores.length > 0 || item.store_content.store_groups.length > 0 || item.store_content.exclude_stores.length > 0) {
            vm.isDefaultApplicable = false
          }

          vm.device_type = []
          if (item.device_type && item.device_type.length > 0) {
            for (let i of item.device_type) {
              let getDeviceValue = vm.sale_channels[vm.$session.get('lang')].filter(channel => channel.value === i)
              vm.device_type.push({
                value: getDeviceValue[0].value,
                text: getDeviceValue[0].text,
              })
            }
          }

          // get store group list
          vm.axios.outlet.getStoreGroupList('?limit=9999', function (respone) {
            let result = respone.data.data.items
            for (let i in result) {
              let groupValue = {  name_tmp: result[i].name[vm.$session.get('lang')],
                                  name: result[i].name,
                                  uuid: result[i].uuid,
                                  id: result[i].id,
                                  outlet_ids: result[i].outlet_ids
              }
              if (item.store_content.store_groups.indexOf(result[i].uuid) < 0) {
                vm.store_group.push(groupValue)
              } else {
                vm.store_group_temp.push(groupValue)
              }
              vm.storeGroupListOrigin.push(groupValue)
            }
            vm.checkFlagAplicable()
          }, error => {
            vm.checkFlagAplicable()
            console.log('error', error)
          })

          // get store list
          vm.axios.outlet.getStoreListUnlimit('?disposition=ALL', function (respone) {
            let result = respone.data.data.items
            for (let i in result) {
              let storeValue = {  name_tmp: result[i].code + ' - ' + result[i].name,
                                  name: result[i].name,
                                  uuid: result[i].uuid,
                                  id: result[i].id,
                                  code : result[i].code
              }
              if (item.store_content.stores.indexOf(result[i].uuid) >= 0) {
                vm.store_temp.push(storeValue)
              } else {
                vm.store_option.push(storeValue)
              }
              vm.storeListOrigin.push(storeValue)
            }
            vm.checkFlagAplicable()
          }, error => {
            vm.checkFlagAplicable()
            console.log(error)
          })

          // change date for special_dates
          let special_dates = []
          for (let k in item.special_dates) {
            special_dates.push({
              'date': vm.convertDateFormat(item.special_dates[k].date),
              'active': item.special_dates[k].active,
              'from': item.special_dates[k].from,
              'name': item.special_dates[k].name,
              'status': item.special_dates[k].status,
              'to': item.special_dates[k].to
            })
          }
          item.special_dates = special_dates

          // change date for opening_times
          let opening_times = []
          for (let i in vm.daysOfWeek) {
            opening_times[vm.daysOfWeek[i]] = {
              day: vm.daysOfWeek[i],
              opening: '08:00:00',
              closing: '23:00:00',
              active: 1
            }
          }
          if (item.opening_times != null && item.opening_times.length > 0) {
            opening_times = []
            for (let i in item.opening_times) {
              opening_times[item.opening_times[i].day] = {
                day: item.opening_times[i].day,
                opening: item.opening_times[i].opening,
                closing: item.opening_times[i].closing,
                active: item.opening_times[i].active
              }
            }
          }
          item.opening_times = opening_times

          for (let p in item.prices) {
            item.prices[p].from = vm.convertDateFormat(item.prices[p].from)
            item.prices[p].to = vm.convertDateFormat(item.prices[p].to)
            item.prices[p].price_without_tax = item.prices[p].price_without_tax != null ? item.prices[p].price_without_tax : []
            item.prices[p].point = item.prices[p].point != null ? item.prices[p].point : []
          }

          vm.displayCategory = []
          for (let key in item.display_categories) {
            vm.displayCategory.push({
              value: item.display_categories[key]['id'],
              text: item.display_categories[key]['name'][vm.$session.get('lang')]
            })
          }
          vm.subDisplayCategory = []
          for (let key in item.sub_display_categories) {
            vm.subDisplayCategory.push({
              value: item.sub_display_categories[key]['id'],
              text: item.sub_display_categories[key]['name'][vm.$session.get('lang')]
            })
          }
          
          if (vm.config_attribute_combo) {
            for (let key in item.menu_attributes) {
              vm.displayAttributes.push({
                value: item.menu_attributes[key]['uuid'],
                text: item.menu_attributes[key]['name'][vm.$session.get('lang')]
              })
            }
          }

          vm.allow_type = []
          for (let key in item.allow_type) {
            for (let i in vm.allow_type_statuses[vm.$session.get('lang')]) {
              if(vm.allow_type_statuses[vm.$session.get('lang')][i].value == item.allow_type[key]) {
                vm.allow_type.push(vm.allow_type_statuses[vm.$session.get('lang')][i])
              }
            }
          }

          vm.owner_code = []
          for (let key in item.owner_code) {
            for (let i in vm.owner_codes) {
              if(vm.owner_codes[i].value == item.owner_code[key]) {
                vm.owner_code.push(vm.owner_codes[i])
              }
            }
          }

          for (let i in vm.item) {
            if (i == 'sequence') {
              if (item.sequence == null) {
                vm.item[i] = 0
              } else {
                vm.item[i] = item[i]
              }
            } else {
              vm.item[i] = item[i]
            }
          }
          if (item.prices.length > 0) {
            vm.priceStatus = true
          } else {
            let prices = {}
            for (let t in vm.tier) {
              prices[t] = 0
            }
            item.prices.push({
              from: defaultDateFrom,
              to: defaultDateTo,
              price: prices,
              price_without_tax: prices,
              tax_rate: 0,
              active: 1
            })
          }
          for (let i in vm.images) {
            vm.imageData[vm.images[i]] = item.image != null && item.image[vm.images[i]] != null ? item.image[vm.images[i]] : ''
          }

          //item.customize.sale_from = (item.customize == null || item.customize.sale_from == 'Invalid date' || item.customize.sale_from == '__-__-____') ? defaultDateFrom : vm.convertDateFormat(item.customize.sale_from)
          //item.customize.sale_to = (item.customize == null || item.customize.sale_to == 'Invalid date' || item.customize.sale_to == '__-__-____') ? defaultDateTo : vm.convertDateFormat(item.customize.sale_to)
          //vm.item.sale_from = item.customize.sale_from
          //vm.item.sale_to = item.customize.sale_to

          // process display date
          if (item.display_start == '' || item.display_start == 'Invalid date' || item.display_start == '__-__-____') {
            vm.item.display_start = vm.revertDateFormat(defaultDateFrom)
          } else {
            vm.item.display_start = item.display_start
          }
          if (vm.item.display_end == '' || vm.item.display_end == 'Invalid date' || vm.item.display_end == '__-__-____') {
            vm.item.display_end = vm.revertDateFormat(defaultDateTo)
          } else {
            vm.item.display_end = item.display_end
          }

          // process selling date
          if (item.selling_start == '' || item.selling_start == null ||
            item.selling_start == 'Invalid date' || item.selling_start == '__-__-____') {
            vm.item.selling_start = item.display_start
          } else {
            vm.item.selling_start = item.selling_start
          }
          if (item.selling_end == '' || item.selling_end == null ||
            item.selling_end == 'Invalid date' || item.selling_end == '__-__-____') {
            vm.item.selling_end = item.display_end
          } else {
            vm.item.selling_end = item.selling_end
          }
          if (item.disposition == null || item.disposition.length == 0) {
            vm.takeaway = 0
            vm.delivery = 0
            vm.dinein = 0
          } else {
            if (item.disposition.indexOf('C') >= 0) {
              vm.takeaway = 1
            } else {
              vm.takeaway = 0
            }
            if (item.disposition.indexOf('D') >= 0) {
              vm.delivery = 1
            } else {
              vm.delivery = 0
            }
            if (item.disposition.indexOf('R') >= 0) {
              vm.dinein = 1
            } else {
              vm.dinein = 0
            }
          }
          if (vm.isShowSEOConfiguration()) {
            vm.$root.$emit('getSeoDetail', item.uuid, item.customize, item)
          }
          for (let i in item.customize) {
            vm.item[i] = item.customize[i]
          }
          vm.item.customize = item.customize
          if (vm.item.content_status == 75) {
            vm.circle_load = setInterval(() => {
              vm.axios.menu.getComboContentStatus('ids=' + vm.item.id, function (response) {
                for (let i in response.data.data) {
                  let item = response.data.data[i]
                  if (item.id == vm.item.id) {
                    vm.item.content_status = item.content_status
                  }
                }
              })
            }, 60000)
          }
          vm.updateSEOUrl(vm.item.friendly_seo_name || '')
          vm.updateCustomizeField = true
        })
      }
    },
    beforeDestroy: function () {
      if (vm.circle_load != null) {
        clearInterval(vm.circle_load)
        vm.circle_load = null
      }
    },
    watch: {
      'modelShowApplicable': function (newVal, oldVal) {
        vm.store_option = this._.sortBy(this.store_option, ['name_tmp'])
        vm.store_exclude_option = this._.sortBy(this.store_exclude_option, ['name_tmp'])
        vm.store_temp = this._.sortBy(this.store_temp, ['name_tmp'])
        vm.store_exclude_temp = this._.sortBy(this.store_exclude_temp, ['name_tmp'])
        vm.store_group = this._.sortBy(this.store_group, ['name_tmp'])
        vm.store_group_temp = this._.sortBy(this.store_group_temp, ['name_tmp'])
        if (newVal) {
          vm.needReset = true
          vm.applicableBeforeOpen.store_temp = vm._.cloneDeep(vm.store_temp)
          vm.applicableBeforeOpen.store_exclude_temp = vm._.cloneDeep(vm.store_exclude_temp)
          vm.applicableBeforeOpen.store_option = vm._.cloneDeep(vm.store_option)
          vm.applicableBeforeOpen.store_exclude_option = vm._.cloneDeep(vm.store_exclude_option)
          vm.applicableBeforeOpen.store_group = vm._.cloneDeep(vm.store_group)
          vm.applicableBeforeOpen.store_group_temp = vm._.cloneDeep(vm.store_group_temp)
        } else {
          if (vm.needReset) {
            vm.store_temp = vm._.cloneDeep(vm.applicableBeforeOpen.store_temp)
            vm.store_exclude_temp = vm._.cloneDeep(vm.applicableBeforeOpen.store_exclude_temp)
            vm.store_option = vm._.cloneDeep(vm.applicableBeforeOpen.store_option)
            vm.store_exclude_option = vm._.cloneDeep(vm.applicableBeforeOpen.store_exclude_option)
            vm.store_group = vm._.cloneDeep(vm.applicableBeforeOpen.store_group)
            vm.store_group_temp = vm._.cloneDeep(vm.applicableBeforeOpen.store_group_temp)
          }
        }
      },
      'item.duration_date' (newVal, oldVal) {
        let val = parseInt(newVal)
        if (newVal == '') {
          //vm.item.selling_start = ''
          //vm.item.selling_end = ''
        } else {
          if (val > 0) {
            if ((vm.item.selling_start == '' && vm.item.selling_end == '') || (vm.item.selling_start == '__-__-____' && vm.item.selling_end == '__-__-____')) {
              vm.item.selling_start = vm.item.display_start
              vm.item.selling_end = vm.item.display_end
            }
          } else {
            //vm.item.selling_start = ''
            //vm.item.selling_end = ''
          }
        }
      },
      displayCategory: function (val) {
        vm.refreshDisplayCategory()
      },
      'dataTable.currentPage': function (val) {
        vm.refreshData()
      },
      'dataTable.perPage': function (val) {
        vm.refreshData()
      },
      'item.friendly_seo_name': function (val) {
        vm.updateSEOUrl(val)
      }
    }
  }
</script>
<style scoped>

  .back-button {
    padding-top: 30px;
    padding-left: 25px;
    width: 95px;
    float: left;
  }
  .statuses {
    width: calc(60% - 95px);
    float: left;
  }
  /*Form Wizard*/
  .bs-wizard {border-bottom: solid 1px #e0e0e0; padding: 0 0 0 0;}
  .bs-wizard > .bs-wizard-step {padding: 0; position: relative;}
  .bs-wizard > .bs-wizard-step + .bs-wizard-step {}
  .bs-wizard > .bs-wizard-step .bs-wizard-stepnum {color: #595959; font-size: 12px; margin-bottom: 5px;}
  .bs-wizard > .bs-wizard-step .bs-wizard-info {color: #999; font-size: 12px; font-weight: 600}
  .bs-wizard > .bs-wizard-step > .bs-wizard-dot {position: absolute; width: 30px; height: 30px; display: block; background: #fbe8aa; top: 45px; left: 50%; margin-top: -15px; margin-left: -15px; border-radius: 50%;}
  .bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {content: ' '; width: 14px; height: 14px; background: #fbbd19; border-radius: 50px; position: absolute; top: 8px; left: 8px; }
  .bs-wizard > .bs-wizard-step > .progress {position: relative; border-radius: 0px; height: 8px; box-shadow: none; margin: 20px 0;}
  .bs-wizard > .bs-wizard-step > .progress > .progress-bar {width:0px; box-shadow: none; background: #fbe8aa;}
  .bs-wizard > .bs-wizard-step.complete > .progress > .progress-bar {width:100%;}
  .bs-wizard > .bs-wizard-step.active > .progress > .progress-bar {width:50%;}
  .bs-wizard > .bs-wizard-step.error > .bs-wizard-dot {background-color: #e4e5e6; font-size: 30px; line-height: 20px; text-align: center; color: #e6322b}
  .bs-wizard > .bs-wizard-step.error > .bs-wizard-dot:after {display: none}
  .bs-wizard > .bs-wizard-step.running > .bs-wizard-dot {background-color: #e4e5e6; font-size: 30px; line-height: 20px; text-align: center;}
  .bs-wizard > .bs-wizard-step.running > .bs-wizard-dot:after {background-color: #e4e5e6;}
  .bs-wizard > .bs-wizard-step:first-child.active > .progress > .progress-bar {width:0%;}
  .bs-wizard > .bs-wizard-step:last-child.active > .progress > .progress-bar {width: 100%;}
  .bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {background-color: #e4e5e6;}
  .bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {opacity: 0;}
  .bs-wizard > .bs-wizard-step:first-child  > .progress {left: 50%; width: 50%;}
  .bs-wizard > .bs-wizard-step:last-child  > .progress {width: 50%;}
  .bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot{ pointer-events: none; }

  .bs-wizard > .bs-wizard-step > .progress{
    background-color: #e4e5e6;
  }

  .menu-form .btn-save {
    float: left !important;
    width: 40% !important;;
    padding-right: 22px;
    padding-top: 30px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
</style>
<style >
  .form-check-required.is-invalid ~ .invalid-feedback {
    display: block;
  }

  .form-check-required.is-invalid {
    border: 1px solid #f86c6b
  }

  .form-check-required.is-invalid .multiselect__tags {
    border: none !important;
  }

  .modal-copy .modal-xl {
    margin-top: 5px;
  }

  .input-group-text .custom-checkbox {
    margin-right: 0px;
    padding-left: 1.0rem;
  }

  .input-group-text {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding: 0.375rem 0.75rem;
    margin-bottom: 0;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #3e515b;
    text-align: center;
    white-space: nowrap;
    background-color: #f8f9fa;
    border: 1px solid #e4e5e6;
  }

  .previewImage {
    width: 100%;
  }

  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }

  .points i {
    position: absolute;
  }

  .step-commit {
    margin-left: calc(0% - 10px);
  }

  .step-updated {
    margin-left: calc(33% - 15px);
  }

  .step-publishing {
    margin-left: calc(66% - 15px);
  }

  .step-publish {
    margin-left: calc(100% - 20px);
  }

  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }

  .current-point {
    font-size: 30px;
  }

  .img-min-height {
    height: 200px;
  }

  .img-min-height-modal {
    height: 200px;
  }

  .col-6 {
    float: left;
  }

  .min-width-200 {
    min-width: 200px;
  }



  .menu-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .menu-form div.header,
  .menu-form .header .card-header {
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .store_group_content {
    background-color: #E1E6EB;
    border-radius: 3px;
  }

  .storeGroupLabel {
    margin-top: 15px;
  }
  .storeTab {
    border-radius: 17.5px;
    background-color: #82909B;
    padding: 10px 13px 12px 10px;
    position: relative;
    display: inline-block;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
  }

  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #2a2c36;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .menu-form .btn-primary .fa{
    font-size: 20px;
  }
  .pt-05{
    padding: 0.5rem;
  }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .form-check-required.is-invalid ~ .invalid-feedback{
    display: block;
  }
  .form-check-required.is-invalid {
    border: 1px solid #f86c6b
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background-color: #41b883 !important;
  }
  .multiselect__tags {
    border: 1px solid #BABFD8 !important;
  }
  .form-check-required.is-invalid .multiselect__tags {
    border: none !important;
  }
  .multiselect__single  {
    font-size: 15px !important;
  }

  .metadata-description {
    margin-top: 0.25rem;
    font-size: 80%;
  }

  .invalid {
    color: #f86c6b;
  }

  .snippet-preview {
    border: 1px solid #e4e5e6;
    padding: 10px;
    height: 100px;
    overflow-y: auto;
  }

  .long-meta-description {
    max-width: 600px
  }

  .snippet-preview-product-title {
    display: inline-block;
    line-height: 1.3;
    margin-bottom: 3px;
    font-family: arial,sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    padding: 0;
    color: #1a0dab;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0,0,0,.1);
  }

  .snippet-preview-meta-description {
    color:#3c4043;
    padding-top: 0;
    margin-bottom: 0;
    text-align: left;
    font-family: arial,sans-serif;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/combo/BaseForm.vue